/**
 * Official product identity (decision D-14.1). Only the user-visible name
 * changes: the repository, package, database and environment identifiers keep
 * their existing technical names.
 */
export const PRODUCT_NAME = 'AI Learning Companion'
export const PRODUCT_TAGLINE = 'Learn · Practice · Improve · Track'

export interface ProductBrandProps {
  /** Show the tagline under the name. */
  readonly tagline?: boolean
  /** Render the name as the page's `h1` (login) instead of plain text. */
  readonly asHeading?: boolean
  readonly className?: string
}

export function ProductBrand({
  tagline = false,
  asHeading = false,
  className = '',
}: ProductBrandProps): React.JSX.Element {
  const Name = asHeading ? 'h1' : 'p'
  return (
    <div className={className}>
      <Name
        lang="en"
        className={asHeading ? 'text-2xl font-semibold' : 'text-base font-semibold'}
      >
        {PRODUCT_NAME}
      </Name>
      {tagline && (
        <p lang="en" className="text-base text-slate-600 dark:text-slate-400">
          {PRODUCT_TAGLINE}
        </p>
      )}
    </div>
  )
}
